import * as React from "react";
import { Datagrid, TextField } from "react-admin";
import { DefaultPerPageSize } from "../../../Constants/Constant";
import { useVerifyPermission } from "@airborne/react-admin";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { CustomDateField } from "../../../Components/CustomDateField";
import UpdatedByField from "../../../Components/ReferenceFields/UpdatedBy/UpdatedByField";
import FilterToolbar from "../../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType } from "../../../Enums/FilterTypes";
import { ShippingAddressExcelHeader, ShippingAddressExcelName } from "./Excel";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { SourceVwUser } from "../../../Constants/Source";
import { ShippingAddressDeleteButton } from "./ShippingAddressDeleteButton";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const ShippingAddressList = props => {
  useVerifyPermission("shippingaddresss", "read");

  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
      fetchRelatedRecords(records, "updatedBy", SourceVwUser).then(updatedBy => {
        const data = records.map(record => ({
          ...record,
          createdBy: `${createdBy[record.createdBy]?.registerId} - ${createdBy[record.createdBy]?.name}`,
          updatedBy: `${updatedBy[record.updatedBy]?.registerId} - ${updatedBy[record.updatedBy]?.name}`,
        }));

        ExcelExport(
          ShippingAddressExcelHeader,
          data.map(v => [
            v.customer.ownerCode,
            v.airportCode,
            v.attentionName,
            v.attentionPhone,
            v.consigneeAddress,
            v.consigneeName,
            v.shipAddress,
            v.email,
            v.createdBy,
            v.createdDate,
            v.updatedBy,
            v.updatedDate,
          ]),
          ShippingAddressExcelName
        );
      });
    });
  };

  return (
    <PoolList
      {...props}
      title={"Shipping Address"}
      perPage={DefaultPerPageSize}
      bulkActionButtons={false}
      filters={
        <FilterToolbar
          dataSource={[
            {
              source: "customer.ownerCode",
              inputType: FilterInputType.Text,
              label: "Customer",
            },
            {
              source: "airportCode",
              inputType: FilterInputType.Text,
              label: "Airport Code",
            },
            {
              source: "attentionName",
              inputType: FilterInputType.Text,
              label: "Attention Name",
            },
            {
              source: "attentionPhone",
              inputType: FilterInputType.Text,
              label: "Attention Phone",
            },
            {
              source: "consigneeAddress",
              inputType: FilterInputType.Text,
              label: "Consignee Address",
            },
            {
              source: "consigneeName",
              inputType: FilterInputType.Text,
              label: "Consignee Name",
            },
            {
              source: "shipAddress",
              inputType: FilterInputType.Text,
              label: "Shipping Address",
            },
            {
              source: "email",
              inputType: FilterInputType.Text,
              label: "Email",
            },
          ]}
        />
      }
      exporter={ExportToExcel}
    >
      <Datagrid {...props} optimized rowClick="edit">
        <ShippingAddressDeleteButton />
        <TextField source="customer.ownerCode" label="Customer" />
        <TextField source="airportCode" label="Airport Code" />
        <TextField source="attentionName" label="Attention Name" />
        <TextField source="attentionPhone" label="Attention Phone" />
        <TextField source="consigneeAddress" label="Consignee Address" />
        <TextField source="consigneeName" label="Consignee Name" />
        <TextField source="shipAddress" label="Shipping Address" />
        <TextField source="email" label="Email" />
        <CreatedByField label="CREATED BY" link={false} />
        <CustomDateField source="createdDate" showTime />
        <UpdatedByField label="Updated By" link={false} />
        <CustomDateField source="updatedDate" showTime />
      </Datagrid>
    </PoolList>
  );
};

export default ShippingAddressList;
